import clsx from "clsx";
import { IconProps } from "../../types/icons";
import { createColorClasses } from "@/theme/colors";

export const ArrowList = ({
  width = 56,
  height = 10,
  className,
  color,
  decorative = false,
  ariaLabel = "List arrow",
}: IconProps) => {
  const classes = createColorClasses({ color });

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="currentColor"
      viewBox="0 0 56 10"
      className={clsx(className, classes)}
      aria-hidden={decorative}
      aria-label={!decorative ? ariaLabel : undefined}
    >
      <g filter="url(#filter0_d_348_84872)">
        <path
          fill="#fff"
          fillRule="evenodd"
          d="M25.44 2.134a4 4 0 0 1 5.12 0L40 10H16z"
          clipRule="evenodd"
        ></path>
      </g>
      <defs>
        <filter
          id="filter0_d_348_84872"
          width="56"
          height="40.793"
          x="0"
          y="-6.793"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          ></feColorMatrix>
          <feOffset dy="8"></feOffset>
          <feGaussianBlur stdDeviation="8"></feGaussianBlur>
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"></feColorMatrix>
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_348_84872"
          ></feBlend>
          <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow_348_84872"
            result="shape"
          ></feBlend>
        </filter>
      </defs>
    </svg>
  );
};


